import { createAction } from '@reduxjs/toolkit'
import { miningPairT } from '../../constants/bakery/lists.d'

export const updateMiningPairMap = createAction<{list: miningPairT[]}>('bakery/updateMiningPairsMap')
